import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

export const HeadWrap = styled.div`
  text-align: center;
  font-size: 25px;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontBold};
  @media ${theme?.breakpoints?.sm_up} {
    font-size: 36px;
  }
`;
export const SubHeadWrap = styled.div`
  text-align: left;
  font-size: 20px;
  padding: 1.5% 0;
  color: ${COLORS.BTN_GREEN};
  font-family: ${theme.fonts.primaryFontRegular};
  @media ${theme?.breakpoints?.sm_up} {
    font-size: 25px;
    padding: 1.5%;
  }
`;

export const SubHeadWrapBatch = styled.div`
  text-align: left;
  font-size: 16px;
  padding: 1.5%;
  font-family: ${theme.fonts.primaryFontRegular};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 16px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-left: 40px;
  }
`;
export const ImageWrap = styled.div`
  text-align: center;
  margin: 1%;
`;
export const TrainingPage = styled.div`
  display: flex;
  flex-direction: column;
  text-align: justify;
  margin: 40px 30px;
  @media ${theme?.breakpoints?.sm_up} {
    width: 70%;
    margin: 40px auto;
  }
`;

export const Container = styled.div`
  font-family: "Inter", system-ui, sans-serif;
  background: linear-gradient(180deg, #f9f9f9 0%, #f1f4f8 100%);
  min-height: 100vh;
  color: #2b2f38;
`;

export const ArrowIcon = styled.span`
  font-size: 1.1rem;
  color: ${(props) => (props.expanded ? "#00838c" : "#666")};
  transition: transform 0.3s ease;
  transform: ${(props) => (props.expanded ? "rotate(0deg)" : "rotate(0deg)")};
`;

export const HeroOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 20, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
`;

export const HeroContent = styled.div`
  text-align: center;
  color: #fff;
  max-width: 800px;
`;

export const HeroTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  background: linear-gradient(90deg, #00c2b2, #00838c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #e5e5e5;
  margin-top: 1rem;
`;

export const MainSection = styled.section`
  padding: 4rem 2rem;
  width: 90%;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const ImagePlaceholder = styled.div`
  background: url(${(p) => p.bgImage}) center/cover no-repeat;
  height: 400px;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

export const ContentBox = styled.div`
  background: #fff;
  padding: 2.5rem;
  border-radius: 1rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: 0.3s ease;

  &:hover {
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1);
  }
`;

export const ContentTitle = styled.h2`
  color: #00838c;
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export const Description = styled.p`
  color: #293461;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 16px;
  font-family: openSans-Regular, sans-serif;
`;

export const Section = styled.div`
  border-bottom: 1px solid #ececec;
  margin-bottom: 1rem;

  .expand-enter {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }
  .expand-enter-active {
    max-height: 300px;
    opacity: 1;
    transition: all 0.25s ease;
  }
  .expand-exit {
    max-height: 300px;
    opacity: 1;
  }
  .expand-exit-active {
    max-height: 0;
    opacity: 0;
    transition: all 0.25s ease;
  }
`;

export const SectionHeader = styled.button`
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 1.1rem;
  color: #293461;
  transition: color 0.3s ease;

  &:hover {
    color: #00838c;
  }
`;

export const SectionContent = styled.div`
  color: #293461;
  padding-bottom: 1rem;
  font-size: 16px;
  font-family: openSans-Regular, sans-serif;
  line-height: 1.7;

  a {
    color: #00838c;
    text-decoration: none;
  }
`;

export const List = styled.ul`
  padding-left: 1.5rem;
  li {
    margin-bottom: 0.5rem;
  }
`;

export const NumberList = styled.ol`
  padding-left: 1.5rem;
  li {
    margin-bottom: 0.5rem;
  }
`;

export const Heading = styled.span`
  font-family: openSans-SemiBold, sans-serif;
  font-size: 16px;
  color: #00838c;
`;

export const Paragraph = styled.div`
  margin-bottom: 10px;
`;
